import { BrandCard } from "@shltelemedicine/shl-ui-lib";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { Constants } from "../../constants";
import styles from "./ViewPrescriptionPage.module.css";
import ViewPrescription from "../../components/ViewPrescription/ViewPerscription";

export const ViewPrescriptionPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get(Constants.PRESCRIPTION_VIEW_TOKEN_KEY);

  return (
    <BrandCard className={`${styles.wrapper} px-5`} contentClassName="mb-4">
      {!token ? (
        <h5 className="m-0 text-center">
          <FormattedMessage id={"VIEW_PRESCRIPTION.UNABLE_TO_VIEW"} />
        </h5>
      ) : (
        <ViewPrescription token={token} />
      )}
    </BrandCard>
  );
};
